import { SkeletonSidePanel } from 'components/secondaryMarket/shared/SidePanel/SkeletonSidePanel';
import { SidePanelTitle, SkeletonSidePanelTitle } from 'components/secondaryMarket/shared/status/SidePanelTitle';
import { FC } from 'react';
import styled from 'styled-components';

import { ApplyAmendSidePanel } from '../sidePanel/ApplyAmendSidePanel';
import { DoneAmendSidePanel } from '../sidePanel/DoneAmendSidePanel';
import { PendingAmendSidePanel } from '../sidePanel/PendingAmendSidePanel';
import { RejectedAmendSidePanel } from '../sidePanel/RejectedAmendSidePanel';
import type { AmendSidePanelProps } from './sidePanel.connect';

export const StyledDiv = styled.div`
  flex-basis: 40em;
`;

const PanelContent: FC<Omit<AmendSidePanelProps, 'isLoading'>> = ({
  tabType,
  applyStatus,
  canApply,
  comment,
  kycDetails,
  kycScore,
  onApply,
  onCommentChanged,
  onDone,
  onNavigateToOrdersBlotter,
  onReset,
  backendReports,
  validationErrors,
  errorMessage,
}) => {
  switch (applyStatus) {
    case 'idle':
      return (
        <ApplyAmendSidePanel
          tabType={tabType}
          canApply={canApply && applyStatus === 'idle' && validationErrors.length === 0}
          backendReports={backendReports}
          comment={comment}
          kycDetails={kycDetails}
          kycScore={kycScore}
          onApply={onApply}
          onCommentChanged={onCommentChanged}
          validationErrors={validationErrors}
          applyLabelKey="secondaryMarket.sidePanel.label.apply"
          readyLabelKey="secondaryMarket.sidePanel.cpOrder.amendReady"
          notReadyLabelKey="secondaryMarket.sidePanel.cpOrder.amendNotReady"
        />
      );
    case 'loading':
      return <PendingAmendSidePanel tabType={tabType} />;
    case 'success':
      return (
        <DoneAmendSidePanel
          onNavigateToOrdersBlotter={onNavigateToOrdersBlotter}
          onDone={onDone}
          validationErrors={validationErrors}
          tabType={tabType}
        />
      );
    case 'error':
      return <RejectedAmendSidePanel onReset={onReset} errorMessage={errorMessage} tabType={tabType} />;
    default:
      return null;
  }
};
PanelContent.displayName = 'AmendCpOrderSidePanelContent';

export const AmendCpOrderSidePanel: FC<AmendSidePanelProps> = ({ isLoading, ...otherProps }) => {
  return (
    <StyledDiv className="card card-bordered h-100 p-3">
      {isLoading ? (
        <SkeletonSidePanelTitle />
      ) : (
        <SidePanelTitle titleMessageKey="secondaryMarket.sidePanel.label.amend.cpOrder.summary" />
      )}
      {isLoading ? <SkeletonSidePanel /> : <PanelContent {...otherProps} />}
    </StyledDiv>
  );
};

AmendCpOrderSidePanel.displayName = 'AmendCpOrderSidePanel';
